function DashboardSkeleton() {
    return (
      <div className="admin-dashboard admin-dashboard--skeleton" role="status" aria-live="polite">
        <div className="admin-dashboard-header">
          <div className="admin-dashboard-skeleton-title skeleton-pulse" />
          <div className="admin-dashboard-skeleton-subtitle skeleton-pulse" />
        </div>
        <div className="admin-stats-grid">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="admin-stat-card admin-dashboard-skeleton-card">
              <div className="admin-dashboard-skeleton-icon skeleton-pulse" />
              <div className="admin-dashboard-skeleton-stat-content">
                <div className="admin-dashboard-skeleton-value skeleton-pulse" />
                <div className="admin-dashboard-skeleton-label skeleton-pulse" />
              </div>
            </div>
          ))}
        </div>
        <div className="admin-dashboard-content">
          <div className="admin-content-card">
            <div className="admin-dashboard-skeleton-section-title skeleton-pulse" />
            <div className="admin-actions-grid">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="admin-dashboard-skeleton-action skeleton-pulse" />
              ))}
            </div>
          </div>
        </div>
        <span className="admin-dashboard-skeleton-sr">Loading dashboard…</span>
      </div>
    );
  }
  export default DashboardSkeleton;